const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');
const { Base64 } = require('js-base64');
const SEPERATOR = require('../../utils/constants');
const { decode } = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    'Content-Type': 'application/json',
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
     
    paymentDetails(inputParam, metaData){
      const url = getUrl('payments/get');
      const parsedMetaData = parseRequestMetaData(metaData);
    
      const reqOpts = { headers, method: 'POST', json: true }
      let inputs = inputParam.split(SEPERATOR.SEPERATOR);
      
      const body = {
        type: Base64.decode(inputs[0]),
        deviceCode: Base64.decode(inputs[1]),
        channel: Base64.decode(inputs[2]),
        txType: Base64.decode(inputs[3]),
        userId: parsedMetaData.qs.userId,
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        pfId: parsedMetaData.portfolio.pfRelId,
      };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    consentUpdate(inputParam, metaData) {
      const url = getUrl('payments/update');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split(SEPERATOR.SEPERATOR);
      const bodyDecode = JSON.parse(decode(params[0]));
      const body = Object.assign(bodyDecode, {branchCode:apiConfig.branchCode ,language: parsedMetaData.portfolio.language });
      return requestHandler(merge(reqOpts, {
        url,
        body,
      }));
    },

      confirmedPayment(inputParam, metaData){
      const url = getUrl('confirmed-payments/get');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      let inputs = inputParam.split(SEPERATOR.SEPERATOR);
    
      const body = {
        psuId: inputs[0],
        transactionId: inputs[1],
        deviceCode: inputs[2],
        channel: inputs[3],
        branchCode:apiConfig.branchCode ,
        language: parsedMetaData.portfolio.language
      }
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    updatePayment(inputParam, metaData){
    console.log("Inside updatepayment")
    const url = getUrl('confirmed-payments/update');
    const parsedMetaData = parseRequestMetaData(metaData);
    const reqOpts = {
      headers: merge(headers, parsedMetaData.headers),
      method: 'POST',
      json: true
    };
    let inputs = inputParam.split(SEPERATOR.SEPERATOR);
    const body = {
      userId:inputs[0],
      status:inputs[1],
      channel:inputs[2],
      deviceCode:inputs[3],
      txToken:inputs[4],
      txType:inputs[5],
      transactionId:inputs[6],
      versionId:inputs[7],
      id:inputs[8],
      branchCode:apiConfig.branchCode ,
      language: parsedMetaData.portfolio.language
     
    };
    return requestHandler(merge(
      {},
      reqOpts,
      { url, body },
      parsedMetaData
    ));

    }


  };
}

module.exports = apiFactory;


